import { isPaymentCaptured } from './paymentLabels';

/**
 * Rezerwacja wypożyczalni, która naprawdę czeka na potwierdzenie personelu (#157), czyli trafia
 * do zakładki „Nowa”. Online nieopłacone `new` lista pokazuje jako „Nieopłacona” (albo wygasłe),
 * więc plakietki „nowych” ich nie liczą. Filtr po stronie klienta na dokumentach z nasłuchu
 * `status == new`: zapytanie z warunkiem na płatność wymagałoby OR i nowego indeksu.
 */
export const isRentalAwaitingConfirmation = (data: { status?: unknown; paymentMethod?: unknown; paymentStatus?: unknown }) => (
  // Częściowy zwrot i spór też znaczą „wpłata dotarła” (#195): rezerwacja czeka na personel.
  data.status === 'new' && !(data.paymentMethod === 'online' && !isPaymentCaptured(data.paymentStatus))
);
